import { CreditLineStatusEnum } from '@trnsact/trnsact-shared-types';
import { SelectOption } from 'global';

export const creditStatusValues: SelectOption<CreditLineStatusEnum>[] = [
  { value: CreditLineStatusEnum.New, label: 'New' },
  { value: CreditLineStatusEnum.Pending, label: 'Pending' },
  { value: CreditLineStatusEnum.Processing, label: 'Processing' },
  { value: CreditLineStatusEnum.Approved, label: 'Approved' },
  { value: CreditLineStatusEnum.Declined, label: 'Declined' },
  { value: CreditLineStatusEnum.Completed, label: 'Completed' },
  { value: CreditLineStatusEnum.Hold, label: 'Hold' },
];
